import { TRANSACTION_STATUS_OPEN } from '../constants'

const initialState = {
  status: TRANSACTION_STATUS_OPEN
}

const SET_TRANSACTION_STATUS = 'customer-center/transaction/SET_TRANSACTION_STATUS'

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_TRANSACTION_STATUS: {
      return { ...state, status: action.status }
    }
    default: return state
  }
}

export const setTransactionStatus = (status) => {
  return { type: SET_TRANSACTION_STATUS, status }
}



// WEBPACK FOOTER //
// ./src/ducks/transaction.js